module.exports = __webpack_public_path__ + "img/Dantam Bridal 22.7873da14.jpg";